import { useState } from "react";
import { Form, Input, Button, notification, Row } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";

import PttLogo from "../../../static/icon/Ptt_login_logo";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { Label } from "reactstrap";

const NewPassword = () => {
  const history = useHistory();

  const [form] = Form.useForm();
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (values) => {
    setLoading(true);

    const params = new URLSearchParams(history.location.search);
    const emailToken = params.get('token');

    const url = new URL('/api/auth/reset-password', window.location);

    const res = await fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        emailToken,
        pass: values.newPassword,
      }),
    });
    if (res.ok) {
      Swal.fire({
        icon: "success",
        title: "Success !",
        text: "Successfully saved data.",
        showConfirmButton: false,
        timer: 1500,
      });
      setSuccess(true);
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setLoading(false);
  };

  return (
    <div className="h-screen w-full grid md:grid-cols-2">
      <div className="bg-login logo-login text-center hidden lg:grid lg:col-span-1">
        <div className="flex flex-1 h-full justify-center items-center">
          <PttLogo style={{ fontSize: 300, color: "#fff" }} />
        </div>
      </div>
      <div className="lg:col-span-1 md:col-span-2 bg-white">
        <div
          className="cursor-pointer hover:opacity-80 ml-12 top-18 absolute"
          onClick={() => history.push('/login')}
        >
          <svg
            width="24"
            height="22"
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.6666 1.66699L1.33325 11.0003L10.6666 20.3337"
              stroke="#75B5E3"
              stroke-width="2.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.33325 11H22.6666"
              stroke="#75B5E3"
              stroke-width="2.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div
          className="font-medium h-full grid items-center justify-center"
          style={{ display: success === false ? "block" : "none" }}
        >
          <div>
            <div className="grid justify-center">
              <div className="text-6xl  mb-8" style={{ marginTop: 200 }}>
                New password
              </div>
              <span className="text-xl font-medium">
                Enter new password to access account.
              </span>
              <Form
                form={form}
                className="w-102"
                layout="vertical"
                onFinish={submit}
              >
                <Form.Item
                  name="newPassword"
                  label={
                    <span className="text-xl font-medium">New password</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "New password is required."
                    },
                    {
                      min: 8,
                      message: "Please enter a value greater than or equal to 8 character(s)."
                    },
                  ]}
                >
                  <Input.Password
                    className="rounded-lg"
                    size="large"
                    placeholder="New password"
                  />
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  label={
                    <span className="text-xl font-medium">
                      Confirm new password
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Confirm new password is required."
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (getFieldValue("newPassword") === value) return Promise.resolve();
                        return Promise.reject(new Error("The value has to be same with New Password."));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    className="rounded-lg"
                    size="large"
                    placeholder="Confirm new password"
                  />
                </Form.Item>

                <Form.Item className="flex float-right">
                  <Button
                    className="w-52 flex items-center justify-center"
                    size="large"
                    shape="round"
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                  >
                    Reset password
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
        <div
          className="font-medium h-full grid items-center justify-center"
          style={{ display: success === false ? "none" : "flex" }}
        >
          <div
            style={{
              border: "0px solid",
              borderRadius: 15,
              padding: "45px 20px",
              boxShadow: "0px 0px 7px -5px",
              height: 300,
              width: 400,
            }}
          >
            <div className="grid justify-center">
              <CheckCircleFilled style={{ color: "#03B0A8", fontSize: 80 }} />
              <Row className="grid justify-center mt-3">
                <Label style={{ fontSize: 24 }}>Changed Successfully.</Label>
              </Row>
              <Row className="grid justify-center mt-3">
                <Button
                  type="primary"
                  shape="round"
                  // htmlType="submit"
                  onClick={() => history.push('/login')}
                  style={{ width: 120 }}
                >
                  Sign in
                </Button>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
